module.exports = __webpack_public_path__ + "img/锦江宾馆.7619cc4a.gif";